import apiRequest from 'client/helpers/apiRequest';
import Theme, { ThemesPage } from '@interfaces/themes';

export const fetchThemes = () =>
    apiRequest.get<ThemesPage>('/api/themes');

export const fetchTheme = (slug: string) =>
    apiRequest.get<Theme>(`/api/themes/${slug}`);
